import { Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';

// Import your components here
import { Login } from './login/login';
import { Main } from './protected/main/main';
import { Caseload } from './protected/caseload/caseload';
import { ComingSoon } from './coming-soon/coming-soon';
import { DynamicFormComponent } from './protected/dynamic-form/dynamic-form';
import { NotFoundComponent } from './not-found/not-found.component';
import { FormEditorComponent } from './protected/form-editor/form-editor-component';
import { ClientComponent } from './protected/client/client';
import { ContactEventComponent } from './protected/client/controls/contact-event-component/contact-event-component';
import { GuideManageClaims } from './protected/billing/guide-manage-claims/guide-manage-claims';
import { ManageDocuments } from './protected/configuration/hub/manage-documents/manage-documents';

export const routes: Routes = [
  { path: '', component: Login },
  { path: 'login', component: Login },
  { path: 'login/callback', component: OktaCallbackComponent },
  {
    path: 'main', component: Main, canActivate: [OktaAuthGuard],
    children: [
      { path: '', redirectTo:'caseload', pathMatch:'full'},
      { path: 'caseload', component: Caseload, canActivate: [OktaAuthGuard] },
      { path: 'guide-manage-claims', component: GuideManageClaims, canActivate: [OktaAuthGuard] },
      { path: 'form/preview/:pct/:formId/:hubId/:agencyId', component: DynamicFormComponent, canActivate: [OktaAuthGuard] },      
      { path: 'form/:pct/:formId/:clientId/:visitId/:mode', component: DynamicFormComponent, pathMatch: 'full', canActivate: [OktaAuthGuard] },
      { path: 'client/create', redirectTo: 'form/T/6/nul/null/create', pathMatch: 'full' },
      { path: 'client/create/referral', redirectTo: 'form/T/53/nul/null/create', pathMatch: 'full' },
      { path: 'client/summary/:clientId', component: ClientComponent, canActivate: [OktaAuthGuard] },
      { path: 'client/profile/:clientId', redirectTo: 'form/T/6/:clientId/null/edit', pathMatch: 'full' },
      { path: 'client/contact/:clientId/:eventId', component: ContactEventComponent, canActivate: [OktaAuthGuard] },
      { path: 'formeditor/:pct/:formId/:hubId/:agencyId', component: FormEditorComponent, pathMatch: 'full', canActivate: [OktaAuthGuard] },
      { path: 'configuration/hub-documents', component: ManageDocuments, pathMatch: 'full', canActivate: [OktaAuthGuard] },
      { path: '**', component: ComingSoon },
    ],
  },

  { path: '**', component: NotFoundComponent },
];
